import { CommonHelper } from "../helpers/common";
import { LinescoreModel } from "./Linescore";
import { PlayerModel } from "./Player";

export class ScoreboardModel{
    public id: number = 0;
    protected _status:number = 0;
    public get statusCode():number {
        return this._status;
    }
    public get isPreview(): boolean{
        return this.statusCode === 0;
    }
    public get isStarting(): boolean{
        return this.statusCode === 0 || this.statusCode === 3 || this.statusCode === 4;
    }
    public get isLive(): boolean{
        return this.statusCode === 1;
    }
    public get isVideoAvailable(): boolean {
        return this.isLive || this.isFinal;
    }
    public get isFinal(): boolean{
        return this.statusCode === 2;
    }
    public get statusText():string {
        const status: any = {
            0: 'Próximamente',
            1: 'En progreso',
            2: 'Final',
            3: 'Por comenzar',
            4: 'Calentamiento',
            5: 'Suspendido',
            6: 'Pospuesto',
            7: 'Cancelado'
        };
        return typeof status[this.statusCode] !== 'undefined' ? status[this.statusCode] : '';
    }

    public get shortStatus(): string {
        switch(this.statusCode){
            case 0:
                return this.timeAmPm + ' CT';
            case 1:
                return this.linescore.inningCurrent + this.linescore.inningPositionText + '. ' + this.linescore.topBottomText;
            case 2: case 3: case 4: case 5: case 6: case 7:
                const finalText:string = this.statusCode !== 2 ? '' : ' ' + this.linescore.inningCurrent + this.linescore.inningPositionText + '. ' + this.linescore.topBottomText;
                return this.statusText + finalText;
            default:
                return '';
        }
    }

    public get firstStatus(): string {
        switch(this.statusCode){
            case 0: case 3: case 4: case 5: case 6: case 7:
                return this.statusText;
            case 1:
                return this.linescore.inningCurrent + this.linescore.inningPositionText + '. ' + this.linescore.topBottomText;
            default:
                return '';
        }
    }
    public get secondStatus(): string {
        switch(this.statusCode){
            case 0:
                return this.timeAmPm;
            case 1:
                return this.linescore.outs + ' Out' + ( (this.linescore.outs > 1  || this.linescore.outs) == 0? 's' : '');
            case 2:
                return this.statusText + ' ' + this.linescore.inningCurrent + this.linescore.inningPositionText;
            default:
                return '';
        }
    };
    public date: Date = new Date();
    public get timeAmPm(): string {
        return CommonHelper.getTimeAmPm(this.date);
    }
    public linescore: LinescoreModel = new LinescoreModel();
    public audioLink: string = '';
    public gamedayLink: string = '';
    public streaming: string = '';
    public ads: string = '';
    public tvStations: string[] = [];
    public footerInfo: string = '';
    public showResults = false;

    public awayProbablePitcher:PlayerModel = new PlayerModel();
    public homeProbablePitcher:PlayerModel = new PlayerModel();

    public winPitcher:PlayerModel = new PlayerModel();
    public losePitcher:PlayerModel = new PlayerModel();
    public savePitcher:PlayerModel = new PlayerModel();

    public pitcher:PlayerModel = new PlayerModel();
    public batter:PlayerModel = new PlayerModel();
    
    constructor(obj: any = null, date: Date = new Date()) {
        if (obj) {
            this.id = parseInt(obj.boxScore);
            this.footerInfo = obj.footer;
            this.audioLink = obj.audioLink;
            this.gamedayLink = obj.gamedayLink;
            this.streaming = obj.streaming;
            this._status = parseInt(obj.gameStatus);
            this.ads = obj.ads;
            this.tvStations = obj.tvStations;
            const dateStr = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
            this.date = CommonHelper.getDate(dateStr + ' ' + obj.gameTimeH);
            this.linescore = new LinescoreModel(obj);

            this.winPitcher.name = obj.winPitcher;
            this.winPitcher.thumb = obj.winPitcherImg;
            this.winPitcher.team.name = obj.winPitcherTeam === 'home' ? this.linescore.homeTeam.shortName : this.linescore.awayTeam.shortName;
            this.winPitcher.mlbId = obj.winPitcherMlbid;
            this.winPitcher.pitchingStats.era = obj.winPitcherEra;
            this.winPitcher.stats.wins = obj.winPitcherWins;
            this.winPitcher.stats.losses = obj.winPitcherLosses;

            this.losePitcher.name = obj.losePitcher;
            this.losePitcher.thumb = obj.losePitcherImg;
            this.losePitcher.team.name = obj.losePitcherTeam === 'home' ? this.linescore.homeTeam.shortName : this.linescore.awayTeam.shortName;
            this.losePitcher.mlbId = obj.losePitcherMlbid;
            this.losePitcher.pitchingStats.era = obj.losePitcherEra;
            this.losePitcher.stats.wins = obj.losePitcherWins;
            this.losePitcher.stats.losses = obj.losePitcherLosses;

            this.savePitcher.name = obj.savePitcher;
            this.savePitcher.thumb = obj.savePitcherImg;
            this.savePitcher.team.name = obj.savePitcherTeam === 'home' ? this.linescore.homeTeam.shortName : this.linescore.awayTeam.shortName;
            this.savePitcher.mlbId = obj.savePitcherMlbid;
            this.savePitcher.pitchingStats.era = obj.savePitcherEra;
            this.savePitcher.stats.wins = obj.savePitcherWins;
            this.savePitcher.stats.losses = obj.savePitcherLosses;

            this.batter.name = obj.atBat;
            this.batter.thumb = obj.atBatImg;
            this.batter.team.name = obj.atBatTeam === 'home' ? this.linescore.homeTeam.shortName : this.linescore.awayTeam.shortName;
            this.batter.battingStats.avg = obj.atBatAvg;
            this.batter.mlbId = obj.atBatMlbid;
            this.batter.stats.wins = obj.atBatWins;
            this.batter.stats.losses = obj.atBatLosses;

            this.pitcher.name = obj.pitcher;
            this.pitcher.thumb = obj.pitcherImg;
            this.pitcher.team.name = obj.pitcherTeam === 'home' ? this.linescore.homeTeam.shortName : this.linescore.awayTeam.shortName;
            this.pitcher.pitchingStats.era = obj.pitcherEra;
            this.pitcher.mlbId = obj.PitcherMlbid;
            this.pitcher.stats.wins = obj.pitcherWins;
            this.pitcher.stats.losses = obj.pitcherLosses;

            this.awayProbablePitcher.name = obj.awayProbablePitcher;
            this.awayProbablePitcher.thumb = obj.awayProbablePitcherImg;
            this.awayProbablePitcher.team.name = this.linescore.awayTeam.shortName;
            this.awayProbablePitcher.mlbId = obj.awayProbablePitcherMlbid;
            this.awayProbablePitcher.pitchingStats.era = obj.awayProbablePitcherEra;
            this.awayProbablePitcher.stats.wins = obj.awayProbablePitcherWins;
            this.awayProbablePitcher.stats.losses = obj.awayProbablePitcherLosses;

            this.homeProbablePitcher.name = obj.homeProbablePitcher;
            this.homeProbablePitcher.thumb = obj.homeProbablePitcherImg;
            this.homeProbablePitcher.team.name = this.linescore.awayTeam.shortName;
            this.homeProbablePitcher.mlbId = obj.homeProbablePitcherMlbid;
            this.homeProbablePitcher.pitchingStats.era = obj.homeProbablePitcherEra;
            this.homeProbablePitcher.stats.wins = obj.homeProbablePitcherWins;
            this.homeProbablePitcher.stats.losses = obj.homeProbablePitcherLosses;
            
        }
    }
}